export enum AmenitiesTypeEnum {
  LOCATION = 'LOCATION',
  ROOM = 'ROOM',
}
